import {
  useCheckMAMViewOnlyChildType,
  useEnv,
  useProductActive,
  useProductActiveV2,
} from 'src/hooks';

export const useSectionValidation = () => {
  const { isProdEnv } = useEnv();
  const { checkActive } = useProductActiveV2();

  const { isViewOnlyChildActive } = useCheckMAMViewOnlyChildType();
  const { isAccountReceivableDemo, isAccountPayableDemo } = useProductActive();

  const isSendMoney =
    !isViewOnlyChildActive &&
    (checkActive('API_BILLER') ||
      checkActive('API_DISBURSE') ||
      checkActive('BULK_DISBURSEMENT') ||
      checkActive('CLAIM_FUND') ||
      checkActive('INTERNATIONAL_TRANSFER'));

  const isReceiveMoney =
    !isViewOnlyChildActive &&
    (checkActive('EWALLET_AGGREGATOR') ||
      checkActive('PAYMENT_CHECKOUT') ||
      checkActive('PAYMENT_ROUTING') ||
      checkActive('VA_DASHBOARD') ||
      checkActive('API_STATIC_VA') ||
      checkActive('QRIS_STATIC_TRANSACTION'));

  const isExpenseManagement =
    checkActive('VIRTUAL_CREDIT_CARD') ||
    checkActive('VCC_USE_BRIDGE_FUND') ||
    checkActive('PHYSICAL_CARD') ||
    checkActive('REIMBURSEMENT');

  const isCashManagement =
    !isViewOnlyChildActive &&
    (checkActive('CASH_DEPOSIT') ||
      checkActive('CASH_DEPOSIT_API') ||
      checkActive('CASH_DEPOSIT_MACHINE') ||
      checkActive('CASH_WITHDRAWAL') ||
      checkActive('EDC') ||
      checkActive('CASH_WITHDRAWAL_API'));

  const isInvoiceActive =
    isAccountPayableDemo ||
    isAccountReceivableDemo ||
    checkActive('ACCOUNT_PAYABLE') ||
    checkActive('ACCOUNT_RECEIVABLE');

  const isMoreActive =
    checkActive('API_INQUIRY') || checkActive('TRANSACTION_DATA');

  const isShowSection = (sectionTitle = '') => {
    if (!isProdEnv) return true;

    switch (sectionTitle) {
      case 'common_products':
        return (
          isSendMoney ||
          isReceiveMoney ||
          isExpenseManagement ||
          isCashManagement ||
          isInvoiceActive ||
          isMoreActive
        );
      default:
        return true;
    }
  };

  const isShowProduct = (productCategory: string) => {
    switch (productCategory) {
      case 'common_send_money':
        return isSendMoney;
      case 'common_receiveMoney':
        return isReceiveMoney;
      case 'common_expenseManagement':
        return isExpenseManagement;
      case 'common_cashManagement':
        return isCashManagement;
      case 'common_invoice':
        return isInvoiceActive;
      case 'common_supportingFeature':
        return isMoreActive;
      default:
        return false;
    }
  };
  return { isShowSection, isShowProduct };
};
